import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function generateLlmPrompt(requestor) {
  return createReduxPromiseAction(
    ActionTypes.GENERATE_DC_PROMPT,
    (
      organisationId,
      projectId,
      matterId,
      documentId,
      prompt,
      conversationType,
      conversationId,
      previousPromptId,
      issueId,
    ) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}` +
            `/matter/${matterId}` +
            `/document/${documentId}` +
            "/generate_prompt",
          {
            conversation_type: conversationType,
            conversation_id: conversationId,
            previous_prompt_id: previousPromptId,
            new_prompt: prompt,
            ...(issueId && {issue_id: issueId}),
          },
          {withCredentials: true},
        )
        .then(response => ({
          id: conversationId,
          conversation_type: conversationType,
          ...response.data,
        })),
  );
}
